var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        // Place for your code
        $(".block-career-form .file-upload .fake-button").on("click", function () {
            document.querySelector('.block-career-form .file-upload-itself').click();
        });

        $('.block-career-form .file-upload-itself').on('change', function () {
            var fileName = '';
            fileName = $(this).val();
            $('.block-career-form  .file-name').html(fileName);
            $('.block-career-form  .file-required-error').remove();
        });

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=career-form', initializeBlock);
    }
});
